import { get } from "lodash";
import { REGEX_EXPS } from "utils/constants";
import { normalizeTextField, stripAllSpaces } from "utils/helpers/validations";
import { validateIBAN } from "utils/helpers/values";
import * as yup from "yup";

const validation = (messages, { isPayerReceiver = true } = {}) => {
  const string = yup
    .string()
    .typeError(messages.NOT_STRING)
    .required(messages.REQUIRED)
    .nullable();
  const noSpaceString = yup.string().transform(stripAllSpaces);
  const nameValidation = yup
    .string()
    .transform(normalizeTextField)
    .typeError(messages.NOT_STRING)
    .nullable()
    .notRequired()
    .test(
      "is-valid-name",
      messages.INVALID_NAME,
      (value) => !value || REGEX_EXPS.name.test(value),
    );
  const requiredName = yup
    .string()
    .transform(normalizeTextField)
    .typeError(messages.NOT_STRING)
    .test(
      "is-valid-name",
      messages.INVALID_NAME,
      (value) => !value || REGEX_EXPS.name.test(value),
    );
  return yup.object().shape({
    isPayerReceiver: yup.boolean().nullable(),
    payment: yup.object().shape({
      type: string,
      frequency: string,
      debitDay: string,
      payer: yup.object().shape({
        BIC: noSpaceString
          .typeError(messages.NOT_STRING)
          .required(messages.REQUIRED)
          .nullable(),
        IBAN: noSpaceString
          .typeError(messages.REQUIRED)
          .test("validateIBAN", messages.INVALID_IBAN, function (value, ctx) {
            const result = validateIBAN(value);
            if (!result.valid)
              return ctx.createError({
                message: get(messages, result.reason, messages.INVALID_VALUE),
              });

            return true;
          })
          .required(messages.REQUIRED),
        owner: yup.object().shape({
          isAdherent: yup.boolean().typeError(messages.NOT_BOOLEAN),
          firstName: nameValidation,
          lastName: nameValidation,
        }),
      }),
      receiver: isPayerReceiver
        ? yup.object().nullable().notRequired()
        : yup.object().shape({
            IBAN: noSpaceString
              .typeError(messages.REQUIRED)
              .test(
                "validateIBAN",
                messages.INVALID_IBAN,
                function (ibanValue) {
                  if (!ibanValue) return false;
                  const result = validateIBAN(ibanValue);
                  if (!result.valid)
                    return this.createError({
                      message: get(
                        messages,
                        result.reason,
                        messages.INVALID_VALUE,
                      ),
                    });
                  return true;
                },
              )
              .test(
                "different-from-payer",
                get(
                  messages,
                  "RECEIVER_IBAN_SAME_AS_PAYER",
                  messages.RECEIVER_IBAN_SAME_AS_PAYER,
                ),
                function (ibanValue) {
                  if (!ibanValue) return true;
                  const paymentValues = this.from?.[1]?.value;
                  const payerIBAN = paymentValues?.payer?.IBAN;
                  if (!payerIBAN) return true;
                  return ibanValue !== payerIBAN;
                },
              )
              .required(messages.REQUIRED),
            BIC: noSpaceString
              .typeError(messages.NOT_STRING)
              .required(messages.REQUIRED)
              .nullable(),
            owner: yup.object().shape({
              firstName: requiredName.required(messages.REQUIRED),
              lastName: requiredName.required(messages.REQUIRED),
              isAdherent: yup.boolean().typeError(messages.NOT_BOOLEAN),
            }),
          }),
    }),
  });
};

export default validation;
